import styled, {css} from 'styled-components'
import {InputWrapper} from '@/components/ui/input-wrapper/InputWrapper'
import {Dropzone} from '@/components/ui/dropzone/Dropzone'
import {CSSProperties} from 'react'
import {makeInputSizeStyle} from '../input-text/style'
import {Button} from '@/components/ui/button/Button'

export const StyledInputFileWrapper = styled.div<{$width: CSSProperties['width']}>(
    ({$width}) => css`
        width: ${$width};
    `
)

export const StyledInputWrapper = styled(InputWrapper)<{$size: 'md'}>(
    ({$size, theme}) => css`
        ${makeInputSizeStyle(theme)[$size]};

        .file-name {
            flex: 1;
            font-size: ${theme.typography.textSm};
            font-weight: 500;
            color: ${theme.palette.neutral['700']};
        }
    `
)

export const StyledInputFileButton = styled(Button)`
    white-space: nowrap;
`

export const StyledDropzone = styled(Dropzone)<{$width: CSSProperties['width']}>(
    ({$width}) => css`
        width: ${$width};
    `
)
